import { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Button.module.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	className?: string;
}

export const Button: React.VFC<ButtonProps> = ({
	className = '',
	children,
	...rest
}) => {
	return (
		<button
			type="button"
			{...rest}
			className={classNames(styles.button, className, 'fluid-font-t6-bold')}
		>
			{children}
		</button>
	);
};
